
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-4a86e52c9f";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("bcztx", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");

var $aOqKz = parcelRequire("aOqKz");

var $jLuVq = parcelRequire("jLuVq");

var $bThnB = parcelRequire("bThnB");

var $lwkLP = parcelRequire("lwkLP");

var $2XKrJ = parcelRequire("2XKrJ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $827c5561c68e6bc0$var$Stack(entries) {
    var data = this.__data__ = new $1HaXd(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$827c5561c68e6bc0$var$Stack.prototype.clear = $aOqKz;
$827c5561c68e6bc0$var$Stack.prototype["delete"] = $jLuVq;
$827c5561c68e6bc0$var$Stack.prototype.get = $bThnB;
$827c5561c68e6bc0$var$Stack.prototype.has = $lwkLP;
$827c5561c68e6bc0$var$Stack.prototype.set = $2XKrJ;
module.exports = $827c5561c68e6bc0$var$Stack;

});
parcelRegister("aOqKz", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $7df352e5de6c01c4$var$stackClear() {
    this.__data__ = new $1HaXd;
    this.size = 0;
}
module.exports = $7df352e5de6c01c4$var$stackClear;

});

parcelRegister("jLuVq", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e63a6535405040df$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $e63a6535405040df$var$stackDelete;

});

parcelRegister("bThnB", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8a8250063136343f$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $8a8250063136343f$var$stackGet;

});

parcelRegister("lwkLP", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $faacb2b65c84a268$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $faacb2b65c84a268$var$stackHas;

});

parcelRegister("2XKrJ", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");

var $c4hom = parcelRequire("c4hom");

var $czXxz = parcelRequire("czXxz");
/** Used as the size to enable large array optimizations. */ var $22851ebfe11a0c7b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $22851ebfe11a0c7b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $1HaXd) {
        var pairs = data.__data__;
        if (!$c4hom || pairs.length < $22851ebfe11a0c7b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $czXxz(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $22851ebfe11a0c7b$var$stackSet;

});


parcelRegister("2et7A", function(module, exports) {

var $fbsQc = parcelRequire("fbsQc");
/** Built-in value references. */ var $1a037a7befeab862$var$Uint8Array = $fbsQc.Uint8Array;
module.exports = $1a037a7befeab862$var$Uint8Array;

});

parcelRegister("aN7pp", function(module, exports) {

var $4OMfZ = parcelRequire("4OMfZ");

var $kqsZv = parcelRequire("kqsZv");

var $ldH3d = parcelRequire("ldH3d");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7db43a3f56f13990$var$getAllKeys(object) {
    return $4OMfZ(object, $ldH3d, $kqsZv);
}
module.exports = $7db43a3f56f13990$var$getAllKeys;

});
parcelRegister("4OMfZ", function(module, exports) {

var $1qvtu = parcelRequire("1qvtu");

var $epu4p = parcelRequire("epu4p");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $382143c1a6fc866d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $epu4p(object) ? result : $1qvtu(result, symbolsFunc(object));
}
module.exports = $382143c1a6fc866d$var$baseGetAllKeys;

});
parcelRegister("1qvtu", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $10a0a2596e41e14e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $10a0a2596e41e14e$var$arrayPush;

});


parcelRegister("kqsZv", function(module, exports) {

var $4LG6t = parcelRequire("4LG6t");

var $g7VYj = parcelRequire("g7VYj");
/** Used for built-in method references. */ var $edecb95d732ed507$var$objectProto = Object.prototype;
/** Built-in value references. */ var $edecb95d732ed507$var$propertyIsEnumerable = $edecb95d732ed507$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $edecb95d732ed507$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $edecb95d732ed507$var$getSymbols = !$edecb95d732ed507$var$nativeGetSymbols ? $g7VYj : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4LG6t($edecb95d732ed507$var$nativeGetSymbols(object), function(symbol) {
        return $edecb95d732ed507$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $edecb95d732ed507$var$getSymbols;

});
parcelRegister("4LG6t", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $378c36108c179673$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $378c36108c179673$var$arrayFilter;

});

parcelRegister("g7VYj", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $bbda44c1737be57f$var$stubArray() {
    return [];
}
module.exports = $bbda44c1737be57f$var$stubArray;

});



parcelRegister("iHlaM", function(module, exports) {

var $38RsQ = parcelRequire("38RsQ");

var $c4hom = parcelRequire("c4hom");

var $dc5b5 = parcelRequire("dc5b5");

var $c6mom = parcelRequire("c6mom");

var $liOEB = parcelRequire("liOEB");

var $Yvcvv = parcelRequire("Yvcvv");

var $jdev5 = parcelRequire("jdev5");
/** `Object#toString` result references. */ var $d9ccaaa112bb6e7e$var$mapTag = "[object Map]", $d9ccaaa112bb6e7e$var$objectTag = "[object Object]", $d9ccaaa112bb6e7e$var$promiseTag = "[object Promise]", $d9ccaaa112bb6e7e$var$setTag = "[object Set]", $d9ccaaa112bb6e7e$var$weakMapTag = "[object WeakMap]";
var $d9ccaaa112bb6e7e$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $d9ccaaa112bb6e7e$var$dataViewCtorString = $jdev5($38RsQ), $d9ccaaa112bb6e7e$var$mapCtorString = $jdev5($c4hom), $d9ccaaa112bb6e7e$var$promiseCtorString = $jdev5($dc5b5), $d9ccaaa112bb6e7e$var$setCtorString = $jdev5($c6mom), $d9ccaaa112bb6e7e$var$weakMapCtorString = $jdev5($liOEB);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $d9ccaaa112bb6e7e$var$getTag = $Yvcvv;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($38RsQ && $d9ccaaa112bb6e7e$var$getTag(new $38RsQ(new ArrayBuffer(1))) != $d9ccaaa112bb6e7e$var$dataViewTag || $c4hom && $d9ccaaa112bb6e7e$var$getTag(new $c4hom) != $d9ccaaa112bb6e7e$var$mapTag || $dc5b5 && $d9ccaaa112bb6e7e$var$getTag($dc5b5.resolve()) != $d9ccaaa112bb6e7e$var$promiseTag || $c6mom && $d9ccaaa112bb6e7e$var$getTag(new $c6mom) != $d9ccaaa112bb6e7e$var$setTag || $liOEB && $d9ccaaa112bb6e7e$var$getTag(new $liOEB) != $d9ccaaa112bb6e7e$var$weakMapTag) $d9ccaaa112bb6e7e$var$getTag = function(value) {
    var result = $Yvcvv(value), Ctor = result == $d9ccaaa112bb6e7e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $jdev5(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $d9ccaaa112bb6e7e$var$dataViewCtorString:
            return $d9ccaaa112bb6e7e$var$dataViewTag;
        case $d9ccaaa112bb6e7e$var$mapCtorString:
            return $d9ccaaa112bb6e7e$var$mapTag;
        case $d9ccaaa112bb6e7e$var$promiseCtorString:
            return $d9ccaaa112bb6e7e$var$promiseTag;
        case $d9ccaaa112bb6e7e$var$setCtorString:
            return $d9ccaaa112bb6e7e$var$setTag;
        case $d9ccaaa112bb6e7e$var$weakMapCtorString:
            return $d9ccaaa112bb6e7e$var$weakMapTag;
    }
    return result;
};
module.exports = $d9ccaaa112bb6e7e$var$getTag;

});
parcelRegister("38RsQ", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $249b9757c648f5e7$var$DataView = $7oqXh($fbsQc, "DataView");
module.exports = $249b9757c648f5e7$var$DataView;

});

parcelRegister("dc5b5", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $99b069919fabd61d$var$Promise = $7oqXh($fbsQc, "Promise");
module.exports = $99b069919fabd61d$var$Promise;

});

parcelRegister("c6mom", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $8cf76a24c320ca4c$var$Set = $7oqXh($fbsQc, "Set");
module.exports = $8cf76a24c320ca4c$var$Set;

});

parcelRegister("liOEB", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $f82292379ae88733$var$WeakMap = $7oqXh($fbsQc, "WeakMap");
module.exports = $f82292379ae88733$var$WeakMap;

});


parcelRegister("5JKmU", function(module, exports) {

var $fc1mV = parcelRequire("fc1mV");

var $8VKar = parcelRequire("8VKar");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $42d51f88e25814a9$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8VKar(value) && !$8VKar(other)) return value !== value && other !== other;
    return $fc1mV(value, other, bitmask, customizer, $42d51f88e25814a9$var$baseIsEqual, stack);
}
module.exports = $42d51f88e25814a9$var$baseIsEqual;

});
parcelRegister("fc1mV", function(module, exports) {

var $bcztx = parcelRequire("bcztx");

var $d73Yq = parcelRequire("d73Yq");

var $3I8ZU = parcelRequire("3I8ZU");

var $4hGi1 = parcelRequire("4hGi1");

var $iHlaM = parcelRequire("iHlaM");

var $epu4p = parcelRequire("epu4p");

var $jageE = parcelRequire("jageE");

var $03pXg = parcelRequire("03pXg");
/** Used to compose bitmasks for value comparisons. */ var $b0f909cda57cfca6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $b0f909cda57cfca6$var$argsTag = "[object Arguments]", $b0f909cda57cfca6$var$arrayTag = "[object Array]", $b0f909cda57cfca6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $b0f909cda57cfca6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b0f909cda57cfca6$var$hasOwnProperty = $b0f909cda57cfca6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b0f909cda57cfca6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $epu4p(object), othIsArr = $epu4p(other), objTag = objIsArr ? $b0f909cda57cfca6$var$arrayTag : $iHlaM(object), othTag = othIsArr ? $b0f909cda57cfca6$var$arrayTag : $iHlaM(other);
    objTag = objTag == $b0f909cda57cfca6$var$argsTag ? $b0f909cda57cfca6$var$objectTag : objTag;
    othTag = othTag == $b0f909cda57cfca6$var$argsTag ? $b0f909cda57cfca6$var$objectTag : othTag;
    var objIsObj = objTag == $b0f909cda57cfca6$var$objectTag, othIsObj = othTag == $b0f909cda57cfca6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $jageE(object)) {
        if (!$jageE(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bcztx);
        return objIsArr || $03pXg(object) ? $d73Yq(object, other, bitmask, customizer, equalFunc, stack) : $3I8ZU(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $b0f909cda57cfca6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $b0f909cda57cfca6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $b0f909cda57cfca6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bcztx);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bcztx);
    return $4hGi1(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $b0f909cda57cfca6$var$baseIsEqualDeep;

});
parcelRegister("d73Yq", function(module, exports) {

var $iPCwY = parcelRequire("iPCwY");

var $2ljjQ = parcelRequire("2ljjQ");

var $jWXQR = parcelRequire("jWXQR");
/** Used to compose bitmasks for value comparisons. */ var $98bf02e1462d8556$var$COMPARE_PARTIAL_FLAG = 1, $98bf02e1462d8556$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $98bf02e1462d8556$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $98bf02e1462d8556$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $98bf02e1462d8556$var$COMPARE_UNORDERED_FLAG ? new $iPCwY : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$2ljjQ(other, function(othValue, othIndex) {
                if (!$jWXQR(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $98bf02e1462d8556$var$equalArrays;

});
parcelRegister("iPCwY", function(module, exports) {

var $czXxz = parcelRequire("czXxz");

var $2TzuM = parcelRequire("2TzuM");

var $drzX2 = parcelRequire("drzX2");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $db5ae0d92e4bd623$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $czXxz;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$db5ae0d92e4bd623$var$SetCache.prototype.add = $db5ae0d92e4bd623$var$SetCache.prototype.push = $2TzuM;
$db5ae0d92e4bd623$var$SetCache.prototype.has = $drzX2;
module.exports = $db5ae0d92e4bd623$var$SetCache;

});
parcelRegister("2TzuM", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $21bc407e4a6ca11d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $21bc407e4a6ca11d$var$setCacheAdd(value) {
    this.__data__.set(value, $21bc407e4a6ca11d$var$HASH_UNDEFINED);
    return this;
}
module.exports = $21bc407e4a6ca11d$var$setCacheAdd;

});

parcelRegister("drzX2", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $9c99af273d3240d6$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $9c99af273d3240d6$var$setCacheHas;

});


parcelRegister("2ljjQ", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $1b4c874f0e0a19c3$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $1b4c874f0e0a19c3$var$arraySome;

});

parcelRegister("jWXQR", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e861dc677ed43f7d$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $e861dc677ed43f7d$var$cacheHas;

});


parcelRegister("3I8ZU", function(module, exports) {

var $56Gbz = parcelRequire("56Gbz");

var $2et7A = parcelRequire("2et7A");

var $94z4y = parcelRequire("94z4y");

var $d73Yq = parcelRequire("d73Yq");

var $gCJfw = parcelRequire("gCJfw");

var $fQAkw = parcelRequire("fQAkw");
/** Used to compose bitmasks for value comparisons. */ var $2b3c75e288c1ac37$var$COMPARE_PARTIAL_FLAG = 1, $2b3c75e288c1ac37$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $2b3c75e288c1ac37$var$boolTag = "[object Boolean]", $2b3c75e288c1ac37$var$dateTag = "[object Date]", $2b3c75e288c1ac37$var$errorTag = "[object Error]", $2b3c75e288c1ac37$var$mapTag = "[object Map]", $2b3c75e288c1ac37$var$numberTag = "[object Number]", $2b3c75e288c1ac37$var$regexpTag = "[object RegExp]", $2b3c75e288c1ac37$var$setTag = "[object Set]", $2b3c75e288c1ac37$var$stringTag = "[object String]", $2b3c75e288c1ac37$var$symbolTag = "[object Symbol]";
var $2b3c75e288c1ac37$var$arrayBufferTag = "[object ArrayBuffer]", $2b3c75e288c1ac37$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $2b3c75e288c1ac37$var$symbolProto = $56Gbz ? $56Gbz.prototype : undefined, $2b3c75e288c1ac37$var$symbolValueOf = $2b3c75e288c1ac37$var$symbolProto ? $2b3c75e288c1ac37$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2b3c75e288c1ac37$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $2b3c75e288c1ac37$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $2b3c75e288c1ac37$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $2et7A(object), new $2et7A(other))) return false;
            return true;
        case $2b3c75e288c1ac37$var$boolTag:
        case $2b3c75e288c1ac37$var$dateTag:
        case $2b3c75e288c1ac37$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $94z4y(+object, +other);
        case $2b3c75e288c1ac37$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $2b3c75e288c1ac37$var$regexpTag:
        case $2b3c75e288c1ac37$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $2b3c75e288c1ac37$var$mapTag:
            var convert = $gCJfw;
        case $2b3c75e288c1ac37$var$setTag:
            var isPartial = bitmask & $2b3c75e288c1ac37$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $fQAkw);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $2b3c75e288c1ac37$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $d73Yq(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $2b3c75e288c1ac37$var$symbolTag:
            if ($2b3c75e288c1ac37$var$symbolValueOf) return $2b3c75e288c1ac37$var$symbolValueOf.call(object) == $2b3c75e288c1ac37$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $2b3c75e288c1ac37$var$equalByTag;

});
parcelRegister("gCJfw", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $c1a34b895c4e5d70$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $c1a34b895c4e5d70$var$mapToArray;

});

parcelRegister("fQAkw", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b897e4b3e51fe95f$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $b897e4b3e51fe95f$var$setToArray;

});


parcelRegister("4hGi1", function(module, exports) {

var $aN7pp = parcelRequire("aN7pp");
/** Used to compose bitmasks for value comparisons. */ var $31e98dc9ff365c44$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $31e98dc9ff365c44$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $31e98dc9ff365c44$var$hasOwnProperty = $31e98dc9ff365c44$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $31e98dc9ff365c44$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $31e98dc9ff365c44$var$COMPARE_PARTIAL_FLAG, objProps = $aN7pp(object), objLength = objProps.length, othProps = $aN7pp(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $31e98dc9ff365c44$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $31e98dc9ff365c44$var$equalObjects;

});



parcelRegister("1lZ6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fc726477ca8709d$var$_react = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0fc726477ca8709d$var$_baseNew = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0fc726477ca8709d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fc726477ca8709d$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $0fc726477ca8709d$var$_react.default.createElement($0fc726477ca8709d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$0fc726477ca8709d$var$InformationCircleIcon.displayName = "InformationCircleIcon";
var $0fc726477ca8709d$var$_default = module.exports.default = $0fc726477ca8709d$var$InformationCircleIcon;

});

parcelRegister("ih47h", function(module, exports) {

$parcel$export(module.exports, "useFireAnalyticsEvents", function () { return $04eebad2fd486270$export$637f611434c7b092; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $dWbel = parcelRequire("dWbel");
const $04eebad2fd486270$var$EMPTY_ATTRIBUTES = {};
const $04eebad2fd486270$export$637f611434c7b092 = (initialAttributes)=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const pendingEvents = (0, $iSvIT.useRef)([]);
    // Memoize initialAttributes to prevent unnecessary re-renders
    const memoizedInitialAttributes = (0, $iSvIT.useMemo)(()=>initialAttributes !== null && initialAttributes !== void 0 ? initialAttributes : $04eebad2fd486270$var$EMPTY_ATTRIBUTES, [
        initialAttributes
    ]);
    const fireEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        if (analyticsClient) createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            attributes: (0, $7Knp0._)({}, memoizedInitialAttributes, eventPayload["attributes"] || {})
        })).fire();
        else // store events to send later
        pendingEvents.current.push(eventPayload);
    }, [
        analyticsClient,
        createAnalyticsEvent,
        memoizedInitialAttributes
    ]);
    // fires pending events once client is available
    (0, $iSvIT.useEffect)(()=>{
        if (analyticsClient && pendingEvents.current.length > 0) {
            pendingEvents.current.forEach((eventPayload)=>{
                createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
                    attributes: (0, $7Knp0._)({}, memoizedInitialAttributes, eventPayload["attributes"] || {})
                })).fire();
            });
            pendingEvents.current = [];
        }
    // we only need to run this effect when the analytics client changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analyticsClient
    ]);
    const fireUIEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "ui"
        }));
    }, [
        fireEvent
    ]);
    const fireTrackEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "track"
        }));
    }, [
        fireEvent
    ]);
    const fireScreenEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "screen"
        }));
    }, [
        fireEvent
    ]);
    const fireOperationalEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "operational"
        }));
    }, [
        fireEvent
    ]);
    return {
        fireUIEvent: fireUIEvent,
        fireTrackEvent: fireTrackEvent,
        fireScreenEvent: fireScreenEvent,
        fireOperationalEvent: fireOperationalEvent,
        pendingEvents: pendingEvents
    };
};

});


var $f788Q = parcelRequire("f788Q");

var $jhLgK = parcelRequire("jhLgK");
(0, $f788Q.init)((0, $jhLgK.SearchResultsPage));


//# sourceMappingURL=search.c8122512.js.map
